import IMGS from "./imgs/myImgs.js";
import "./App.css";

function CheckStopEngine() {
  return (
    <div className="flex-between">
      <figure className="light-contain-V">
        <span className="light-rnd light-checkStop"></span>
        <figcaption className="light-check-stop">CHECK ENGINE</figcaption>
      </figure>
      <figure className="light-contain-V">
        <span className="light-rnd light-checkStop"></span>
        <figcaption className="light-check-stop">STOP ENGINE</figcaption>
      </figure>
    </div>
  );
}
function FRC() {
  let styles = {
    fontSize: "2rem",
    fontWeight: "900",
  };
  return <h2 style={styles}>FRC</h2>;
}
function IdlePreset() {
  return (
    <div className="flex-between">
      <div className="btn-border btn-border-white">
        <button className="btn btn-idle" onClick="">
          IDLE
        </button>
      </div>
      <ThrottleLight />
      <div className="btn-border btn-border-white">
        <button className="btn btn-preset" onClick="">
          PRESET
        </button>
      </div>
    </div>
  );
}
function IncDec() {
  return (
    <div className="flex-col">
      <div className="btn-border btn-border-orange">
        <button className="btn btn-inc" onClick="">
          <h2>+</h2>
          <h2>INC</h2>
        </button>
      </div>
      <div className="btn-border btn-border-orange">
        <button className="btn btn-dec" onClick="">
          <h2>DEC</h2>
          <h2>-</h2>
        </button>
      </div>
    </div>
  );
}
function Mode() {
  return (
    <div className="btn-border btn-border-white">
      <button className="btn btn-mode" onClick="">
        MODE
      </button>
    </div>
  );
}
function PumpDischarge() {
  let output = 0;
  return (
    <figure className="intake-discharge-box">
      <h2 className="intake-discharge">{output}</h2>
      <figcaption className="intake-dis-figcap">PUMP DISCHARGE</figcaption>
    </figure>
  );
}
function PumpIntake() {
  let output = 0;
  return (
    <figure className="intake-discharge-box">
      <h2 className="intake-discharge">{output}</h2>
      <figcaption className="intake-dis-figcap">PUMP INTAKE</figcaption>
    </figure>
  );
}
function PresssureRPMlights() {
  return (
    <div>
      <figure className="light-contain-H">
        <span className="light-rnd light-pressure"></span>
        <figcaption>PRESSURE</figcaption>
      </figure>
      <figure className="light-contain-H">
        <span className="light-rnd light-rpm"></span>
        <figcaption>RPM</figcaption>
      </figure>
    </div>
  );
}
function PSI() {
  let output = 150;
  return (
    <figure className="intake-discharge-box">
      <h2 className="intake-discharge intake-dis-override">PSI {output}</h2>
      <figcaption>RPM</figcaption>
    </figure>
  );
}

function RPM() {
  let output = 0;
  return (
    <figure className="intake-discharge-box">
      <h2 className="intake-discharge">{output}</h2>
      <figcaption className="rpm">RPM</figcaption>
    </figure>
  );
}
function SilenceMenu() {
  return (
    <div className="flex-between">
      <button className="btn btn-silence" onClick="">
        SILENCE
      </button>
      <button className="btn btn-menu" onClick="">
        MENU
      </button>
    </div>
  );
}
function StatusLights() {
  return (
    <div className="flex-between status-lights-contain">
      <figure className="flex-col">
        <div className="TEMP-status"></div>
        <figcaption className="status-lights-label">OIL</figcaption>
        <img className="status-icons" src={IMGS.oilCan} alt="oil can icon" />
      </figure>
      <figure className="flex-col">
        <div className="TEMP-status"></div>

        <figcaption className="status-lights-label">ENG</figcaption>
        <img className="status-icons" src={IMGS.thermometer} alt="thermometer icon" />
      </figure>
      <figure className="flex-col">
        <div className="TEMP-status"></div>
        <figcaption className="status-lights-label">TRANS</figcaption>
        <img className="status-icons" src={IMGS.transTemp} alt="transmission temperature icon" />
      </figure>
      <figure className="flex-col">
        <div className="TEMP-status"></div>
        <figcaption className="status-lights-label">VOLTS</figcaption>
        <img className="status-icons" src={IMGS.volts} alt="automotive battery icon" />
      </figure>
    </div>
  );
}
function SubRightL() {
  return (
    <div className="sub-right">
      <PresssureRPMlights />
      <Mode />
    </div>
  );
}
function SubRightR() {
  return (
    <div className="flex-col">
      <IncDec />
    </div>
  );
}
function TotalControlLogo() {
  return (
    <div className="flex-between">
      <h2 className="total-control">TOTAL</h2>
      <h2 className="total-control-red"> CONTROL</h2>
    </div>
  );
}
function ThrottleLight() {
  return (
    <figure className="light-contain-V">
      <figcaption className="">THROTTLE</figcaption>
      <span className="light-rnd light-throttle"></span>
      <figcaption className="">READY</figcaption>
    </figure>
  );
}

//const RED = "rgba(210,211,213,255)";
//pallette.RED
function DigitalDisplay(caption, output) {
  return (
    <figure className="intake-discharge-box">
      <h2 className="intake-discharge">{output}</h2>
      <figcaption>{caption}</figcaption>
    </figure>
  );
}

function TEMP() {
  /*let ret = DigitalDisplay("PUMP DISCHARGE", 0);
  ret += DigitalDisplay("PUMP DISCHARGE", 0);*/
  return DigitalDisplay("PUMP DISCHARGE", 0);
}

function App() {
  return (
    <div className="App">
      <main>
        <h1>
          Below is a Prototype for the <br />
          front end of an interactive pump panel GOVERNOR element
        </h1>
        <div className="governor">
          <div className="gov-top-contain">
            <div className="gov-left-contain">
              <TotalControlLogo />
              <PumpDischarge />
              <PumpIntake />
            </div>
            <div className="gov-right-contain">
              <IdlePreset />
              <div className="flex-between">
                <SubRightL />
                <SubRightR />
              </div>
            </div>
          </div>
          <div className="gov-bottom-contain">
            <div className="flex-col">
              <RPM />
              <CheckStopEngine />
            </div>
            <div className="flex-col">
              <PSI />
              <SilenceMenu />
            </div>
            <StatusLights />
          </div>
        </div>
        <div>
          <h3>
            These two images are pictures of <br />
            PHYSICAL governor units the above is based on.
          </h3>
          <div className="flex-center">
            <img src={IMGS.governorTotalFrame} className="govImg" alt="govenor panel" />
            <img src={IMGS.governor} className="govImg" alt="govenor panel" />
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;
